<button
  class="button"
  (click)="clicked.emit($event)"
  [disabled]="disabled()"
  [class.primary]="type() === 'primary'"
  [class.primary-dark]="type() === 'primary-dark'"
  [class.primary-darker]="type() === 'primary-darker'"
  [class.secondary]="type() === 'secondary'"
  [class.ghost]="type() === 'ghost'"
  [class.circle]="border() === 'circle'"
  [class.rounded]="border() === 'rounded'"
  [class.square]="border() === 'square'"
  [class.icon-background]="iconBackground()"
>
  <app-icon glyph [name]="icon()"></app-icon>
</button>
